module.exports = __webpack_public_path__ + "img/plane.bf4d3de3.png";